"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectVirtualGameToken = exports.selectFetchVirtualGameTokenRequest = void 0;
const api_1 = require("../../utils/api");
const defaultRequestState = api_1.requestInitialState;
const selectFetchVirtualGameTokenRequest = (state, virtualGameVendor) => {
    var _a, _b;
    return (_b = (_a = state.virtualGamesProvider[virtualGameVendor]) === null || _a === void 0 ? void 0 : _a.fetchItem) !== null && _b !== void 0 ? _b : defaultRequestState;
};
exports.selectFetchVirtualGameTokenRequest = selectFetchVirtualGameTokenRequest;
const selectVirtualGameToken = (state, virtualGameVendor) => { var _a; return (_a = state.virtualGamesProvider[virtualGameVendor]) === null || _a === void 0 ? void 0 : _a.entry; };
exports.selectVirtualGameToken = selectVirtualGameToken;
//# sourceMappingURL=selectors.js.map